<template>
  <el-drawer
    :title="$t('Common.detail')"
    :visible.sync="visible"
    direction="rtl"
    size="600px"
    :wrapperClosable="false"
    :close-on-press-escape="false"
    :before-close="close"
  >
    <div class="drawer-content">
      <div class="drawer__content-main" style="padding: 18px 48px;">
        <Description>
          <DescriptionItem :span="24" :label="$t('Common.account')">{{
            info.account | format
          }}</DescriptionItem>
          <DescriptionItem :span="24" :label="$t('Common.name')">{{
            info.admin | format
          }}</DescriptionItem>
          <DescriptionItem :span="24" :label="$t('Common.ip')">{{
            info.ip | format
          }}</DescriptionItem>
          <DescriptionItem :span="24" label="URL">{{ info.uri | format }}</DescriptionItem>
          <DescriptionItem :span="24" :label="$t('System.logModuleName')">{{
            info.moduleName | format
          }}</DescriptionItem>
          <DescriptionItem :span="24" :label="$t('System.logOperation')">{{
            info.operation | format
          }}</DescriptionItem>
          <DescriptionItem :span="24" :label="$t('System.logCreateTime')">{{
            info.createTime | formatTime
          }}</DescriptionItem>
          <DescriptionItem :span="24" :label="$t('System.logRequestParams')">{{
            info.params | format
          }}</DescriptionItem>
          <DescriptionItem :span="24" :label="$t('System.logResponseParams')">
            <!--            :contentStyle="{ overflow: 'hidden' }"-->
            {{ info.result | format }}
          </DescriptionItem>
        </Description>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import Description from '@/components/Descriptions'
import DescriptionItem from '@/components/Descriptions/DescriptionsItem'

import { format, formatTime } from '@/utils/utils'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: Object
  },
  components: {
    Description,
    DescriptionItem
  },
  data() {
    return {
      info: {}
    }
  },
  created() {
    if (this.row.id) {
      this.getDetail()
    }
  },
  filters: {
    format(val) {
      return format(val)
    },
    formatTime(val) {
      return formatTime(val)
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    getDetail() {
      const params = {
        id: this.row.id
      }
      this.$ajax
        .get(this.$api.system.log_web_detail, params)
        .then((res) => {
          if (res.data) {
            this.info = res.data
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss"></style>
